export default function PrivacyPolicy() {
    return (
        <div className="policy-page">
            <div className="policy-header">
                <h1>Privacy Policy</h1>
                <p>How we collect, use, and protect your information.</p>
            </div>

            <div className="policy-content">
                <h2>1. Introduction</h2>
                <p>
                    At Akes, accessible from{" "}
                    <a
                        href="https://goreeduhub.cloud/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://goreeduhub.cloud/
                    </a>
                    , we value your privacy and are committed to protecting your
                    personal information.
                </p>

                <h2>2. Information We Collect</h2>
                <p>We may collect the following information:</p>
                <ul>
                    <li>Name, email address, and contact number</li>
                    <li>Shipping address</li>
                    <li>Payment details, processed securely through payment gateways</li>
                    <li>Browsing and purchase history</li>
                </ul>

                <h2>3. How We Use Your Information</h2>
                <p>
                    The information we collect may be used for the following purposes:
                </p>
                <ul>
                    <li>To process and fulfill your orders</li>
                    <li>To communicate updates about your purchases</li>
                    <li>To provide customer support</li>
                    <li>To improve your user experience</li>
                    <li>To improve our products and services</li>
                </ul>

                <h2>4. Payment Information</h2>
                <p>
                    Payment transactions are processed securely through authorized
                    payment service providers and payment gateways. We do not
                    unnecessarily store sensitive payment information such as complete
                    card details on our servers.
                </p>

                <h2>5. Data Protection</h2>
                <p>
                    We take reasonable measures to protect your personal information
                    from unauthorized access, alteration, disclosure, or destruction.
                    Sensitive information is transmitted using appropriate security
                    measures.
                </p>

                <h2>6. Sharing of Information</h2>
                <p>
                    We do not sell, trade, or rent your personal information to third
                    parties. Information may be shared with trusted service providers
                    when necessary to process payments, fulfill orders, provide
                    services, or operate our website.
                </p>

                <h2>7. Contact Us</h2>
                <p>
                    If you have any questions or concerns regarding this Privacy Policy,
                    please contact us at{" "}
                    <a href="mailto:gorelearning.crm@gmail.com">
                        gorelearning.crm@gmail.com
                    </a>
                    .
                </p>
            </div>
        </div>
    );
}